import Vue from 'vue'

const mutations = {
    setFilter(state, { filter }) {
        Vue.set(state.entities, filter.code, filter)
    },
}

export default mutations
